import TimelineMax from 'TimelineMax'
import { select } from "@assets/scripts/utils";

export default function () {
    let svg = select('.i5')[0]
    if(!svg) return
    svg = svg.contentDocument

    const fingerTop = svg.querySelector('.finger-top')
    const fingerBottom = svg.querySelector('.finger-bottom')
    const fingerTl = new TimelineMax()
    const stringmask = svg.querySelector('.stringmask')

    fingerTl.add(() => {
            TweenMax.fromTo(fingerTop, 0.5, { y: '0%' }, { y: '100%', ease: SteppedEase.config(3) })
            TweenMax.fromTo(fingerBottom, 0.5, { y: '0%' }, { y: '-100%', ease: SteppedEase.config(3) })
            TweenMax.fromTo(stringmask, 0.5, { y: '-61%' }, { y: '0%', ease: SteppedEase.config(2) })
    })
        .add(() => {
            TweenMax.to(fingerTop, 0.5, { y: '0%', ease: SteppedEase.config(3) })
            TweenMax.to(fingerBottom, 0.5, { y: '0%', ease: SteppedEase.config(3) })
        }, 0.5)
        .repeatDelay(0.5)
        .repeat(-1)

    const rhombs = select('.rhomb', svg)
    const rhombtl = new TimelineMax()

    rhombtl.add(() => {
            TweenMax.to(rhombs[0], 2, { y: '30%', ease: SteppedEase.config(4) })
            TweenMax.to(rhombs[1], 1, { x: '50%', ease: SteppedEase.config(4) })
            TweenMax.to(rhombs[2], 1, { x: '-100%', ease: SteppedEase.config(4) })
    })
        .add(() => {
            TweenMax.to(rhombs[1], 1, { x: '0%', ease: SteppedEase.config(4) })
            TweenMax.to(rhombs[2], 3, { x: '0%', ease: SteppedEase.config(4) })
        }, 1)
        .add(() => {
            TweenMax.to(rhombs[0], 1, { y: '0%', ease: SteppedEase.config(4) })
        }, 2)
        .repeatDelay(1)
        .repeat(-1)

    const crates = svg.querySelector('.crates')
    const cratestl = new TimelineMax()
    cratestl.fromTo(crates, 1.5, { x: '10%' }, { x: '-20%', ease: SteppedEase.config(4) }).repeat(-1)

    const dot = svg.querySelector('.dot')
    const dottl = new TimelineMax()
    dottl.fromTo(dot, 1, { autoAlpha: 0 }, { autoAlpha: 1, ease: SteppedEase.config(1) }).repeat(-1)

    const lights = select('.light', svg)
    const lightstl = new TimelineMax

    TweenMax.set(lights, { autoAlpha: 0 })

    lightstl.add(() => {
            TweenMax.set([lights[0], lights[1]], { autoAlpha: 1 })
        })
        .add(() => {
            TweenMax.set(lights, { autoAlpha: 0 } )
        }, 0.2)
        .add(() => {
            TweenMax.set([lights[0], lights[2]], { autoAlpha: 1 })
        }, 0.4)
        .add(() => {
            TweenMax.set(lights, { autoAlpha: 0 })
        }, 0.6)
        .add(() => {
            TweenMax.set([lights[1]], { autoAlpha: 1 })
        }, 0.8)
        .add(() => {
            TweenMax.set(lights, { autoAlpha: 0 })
        }, 1)
        .repeat(-1)

}
